"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.turkeyTranslations = void 0;
var _types = require("../../../types");
const turkeyTranslations = exports.turkeyTranslations = {
  [_types.ErrorPageTranslationKey.headline]: ' Üzgünüz!',
  [_types.ErrorPageTranslationKey.buttonText]: ' Geri Dön',
  [_types.ErrorPageTranslationKey.text]: ' Bu sayfaya kısa bir süreliğine ulaşılamıyor.',
  [_types.ErrorPageTranslationKey.notFound]: 'Ulaşmaya çalıştığınız sayfa bulunamadı',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Bu sayfaya giriş yetkiniz bulunmamaktadır.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Lütfen e-posta yoluyla Oriflame destek ekibiyle iletişime geçin:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'İstenen URL reddedildi!'
};
